<template>
  <div id="userOrder">
    <Dialog ref="dialog" :config="config" />

    <div class="tabsContainer" v-if="flag">
      <el-tabs v-model="form.status" @tab-click="handleClick" ref="tabs">
        <el-tab-pane :label="allTabText" name="全部"></el-tab-pane>
        <el-tab-pane :label="Tobequoted" name="待报价"></el-tab-pane>
        <el-tab-pane :label="Tobepaid" name="待支付"></el-tab-pane>
        <el-tab-pane :label="orderForDeliveryTabText" name="待发货配送单"></el-tab-pane>
        <el-tab-pane :label="deliveryInTransitTabText" name="运输中配送单"></el-tab-pane>
        <el-tab-pane :label="spanishDeliveryOrderTabText" name="西班牙派送配送单"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="list" v-loading="loading">
      <div class="searchBox">
        <div class="myInput">
          <i class="el-icon-search"></i>
          <input type="text" v-model="form.searchText" @keydown.enter="getData()"
            :placeholder="$fanyi('请输入订单号或配送单号搜索')" />
        </div>
        <el-date-picker v-model="value" type="datetimerange" :range-separator="$fanyi('')"
          :start-placeholder="$fanyi('开始日期')" :end-placeholder="$fanyi('结束日期')" value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
        <button class="searchBtn" @click="
          form.page = 1
        getData(form)
          ">
          {{ $fanyi('搜索') }}
        </button>
        <button class="completed" v-if="flag" @click="Completed(1)">
          {{ $fanyi('已签收') }}
        </button>
        <button v-else @click="Completed" class="return">
          {{ $fanyi('返回') }}
        </button>
      </div>
      <!-- 表格 -->
      <div class="dataBody">
        <div class="myTable">

          <ol class="tableHead">

            <li class="NO" :class="{ flex80: form.status == '待报价' }">NO</li>
            <li class="pordersn"
              :class="{ flex230: form.status == '待报价', flex194: form.status == '待支付', flex210: form.status == '待发货配送单' || form.status == '运输中配送单', }">
              {{ $fanyi('配送单号') }}
            </li>
            <li class="ordersn"
              :class="{ flex230: form.status == '待报价', flex194: form.status == '待支付', flex210: form.status == '待发货配送单' || form.status == '运输中配送单', }">
              {{ $fanyi('订单号') }}
            </li>
            <!-- 提出时间爱 -->
            <li class="time"
              :class="{ flex190: form.status == '待报价', flex110: form.status == '待发货配送单' || form.status == '西班牙派送配送单' || form.status == '待支付' }">
              {{ $fanyi('提出时间') }}
            </li>
            <!-- 签收时间 -->
            <li v-if="form.status == '已签收配送单'" class="signfortime">
              {{ $fanyi('签收时间') }}
            </li>
            <!-- 支付时间 -->
            <li v-if="form.status == '全部' || form.status == '已签收配送单'" class="paymenttime">
              {{ $fanyi('支付时间') }}
            </li>

            <li v-if="form.status !== '待报价'"
              :class="{ flex150: form.status == '运输中配送单' || form.status == '西班牙派送配送单' || form.status == '待支付', }"
              class="internationalfreight">
              {{ $fanyi('国际运费') }}(₴)</li>
            <li v-if="form.status !== '待报价'" class="weight"
              :class="{ flex110: form.status == '运输中配送单', flex90: form.status == '西班牙派送配送单' || form.status == '待支付', }">
              {{
                $fanyi('计费重量') }}(kg)</li>
            <li class="state" :class="{ flex285: form.status == '待报价', flex170: form.status == '运输中配送单', }">{{
              $fanyi('状态') }}</li>
            <li class="operation" v-if="form.status !== '已签收配送单' && form.status != '待报价' && form.status != '运输中配送单'">
              {{ $fanyi('操作') }}
            </li>
          </ol>
          <!-- 表格区域 -->
          <div class="tableBody">
            <ul v-for="(item, index) in tableData" :key="index">
              <li class="NO" :class="{ flex80: form.status == '待报价' }">{{ index + 1 }}</li>
              <!-- 配送单号 -->
              <li class="pordersn"
                :class="{ flex230: form.status == '待报价', flex194: form.status == '待支付', flex210: form.status == '待发货配送单' || form.status == '运输中配送单', }"
                @click="
                  $fun.toPage(
                    '/deliveryDetails?order_sn=' + item.porder_sn + '&status=' + item.status, true)
                  ">
                {{ item.porder_sn }}
              </li>
              <!-- 订单号 -->
              <li class="ordersn"
                :class="{ flex230: form.status == '待报价', flex194: form.status == '待支付', flex210: form.status == '待发货配送单' || form.status == '运输中配送单', }">
                <p v-for="item in item.order_set" :key="item" @click="toDetailPage(item)">
                  {{ item }}
                </p>
              </li>
              <!-- 提出时间 -->
              <li class="time"
                :class="{ flex190: form.status == '待报价', flex110: form.status == '待发货配送单' || form.status == '西班牙派送配送单' || form.status == '待支付' }">
                {{ item.created_at ? item.created_at : '---' }}
              </li>
              <!-- 签收时间 -->
              <li v-if="form.status == '已签收配送单'" class="signfortime">
                {{ item.client_receive ? item.client_receive : '---' }}
              </li>
              <!-- 支付时间 -->
              <li v-if="form.status == '全部' || form.status == '已签收配送单'" class="paymenttime">
                {{ item.client_receive ? item.client_receive : '---' }}
              </li>
              <!-- 国际运费 -->
              <li v-if="form.status !== '待报价'"
                :class="{ flex150: form.status == '运输中配送单' || form.status == '西班牙派送配送单' || form.status == '待支付', }"
                class="internationalfreight">
                {{ item.logistics_price ? item.logistics_price : '---' }}
              </li>
              <!-- 重量 -->
              <li v-if="form.status !== '待报价'"
                :class="{ flex110: form.status == '运输中配送单', flex90: form.status == '西班牙派送配送单' || form.status == '待支付', }"
                class="weight">{{
                  item.weight ? item.weight : '---' }}</li>
              <li class="state" :class="{ flex285: form.status == '待报价', flex170: form.status == '运输中配送单', }">
                {{ $fanyi(item.statusName) }}
              </li>

              <li :class="{ flex150: form.status == '运输中配送单', }"
                v-if="form.status !== '已签收配送单' && form.status !== '待报价' && form.status != '运输中配送单'" class=" operation">
                <button class="Receipt" v-if="item.statusName == '乌克兰国内配送中'" type="primary"
                  @click="qianShou(item.porder_sn)">
                  {{ $fanyi('确认签收') }}
                </button>
                <button class="pay" v-else-if="item.statusName == '等待付款'" type="primary" @click="
                  $fun.toPage(
                    '/deliveryDetails?type=purchase&order_sn=' +
                    item.porder_sn
                  )
                  ">
                  {{ $fanyi('去支付') }}
                </button>
                <span v-else>- -</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="NoDaTa" v-if="tableData ? tableData.length == 0 : false">
          {{ $fanyi('暂无数据') }}
        </div>
      </div>

      <div class="allpag">
        <el-pagination @current-change="handleCurrentChange" :current-page="form.currentPage" :page-size="10"
          :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next,jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Dialog from '../../../../components/public/Dialog.vue'
import { daysDistance, getCurrentDay } from '../../../../utlis/date'

export default {
  components: {
    Dialog,
  },
  data() {
    return {
      getCurrentDay,
      daysDistance,
      allTabText: this.$fanyi('全部') + ` (0)`,
      loading: false,
      value: '', // 时间
      flag: true,// 是否展示已签收
      orderForDeliveryTabText: this.$fanyi('待发货配送单') + ` (0)`,
      deliveryInTransitTabText: this.$fanyi('国际运输中') + ` (0)`,
      Tobepaid: this.$fanyi('待支付') + ` (0)`,
      Tobequoted: this.$fanyi('待报价') + ` (0)`,
      deliveryFormToRakumartTransportCentreTabText:
        this.$fanyi('到达Rakumart物流中心') + ` (0)`,
      spanishDeliveryOrderTabText: this.$fanyi('乌克兰派送中') + ` (0)`,
      internationalLogisticsTabText: this.$fanyi('已签收') + ` (0)`,
      form: {
        status: '全部',
        page: 1,
        pageSize: 10,
        searchText: '',
      },
      config: {
        top: '20vh',
        width: '500px',
        title: this.$fanyi('提示'),
        btnTxt: [this.$fanyi('确定'), this.$fanyi('取消')],
      },
      tableData: [],
      total: 0,
    }
  },
  watch: {
    routerName(val) {
      if (val === 'Usdeliveryunderway') {
        this.form.status = '西班牙派送配送单'
      }
      this.getData()
    },
  },
  computed: {
    routerName() {
      return this.$store.state.router
    },
  },
  created() {

    if (this.$route.query.status) {
      switch (this.$route.query.status) {
        case 'orderForDelivery':
          this.form.status = '待发货配送单'
          break
        case 'deliveryInTransit':
          this.form.status = '运输中配送单'
          break
        case 'deliveryFormToRakumartTransportCentre':
          this.form.status = '到达Rakumart运输中心配送单'
          break
        case 'Usdeliveryunderway':
          this.form.status = '西班牙派送配送单'
          break
        case 'Signedandreceived':
          this.form.status = '已签收配送单'
          this.flag = false
          break
        case 'Tobepaid':
          this.form.status = '待支付'
          break
        case 'internationalFreightToBeQuotedDeliverySheet':
          this.form.status = '待报价'
          break
        default:
          this.form.status = this.$route.query.status
          break
      }
    }
    this.getData()
    this.getTitleNumber()
  },
  methods: {
    //点击配送单单号
    toPdetailPage(item) {
      let baseUrl = window.location.origin
      window.open(baseUrl + `/deliveryDetails?order_sn=${item.porder_sn}`, '_blank')
    },
    //点击订单号
    toDetailPage(item) {

      let baseUrl = window.location.origin
      window.open(baseUrl + `/orderDetails?type=purchase&order_sn=${item}`, '_blank')

    },
    // 获取种类数量数据
    Completed(type) {

      if (type == 1) {

        this.flag = false
        this.form.status = '已签收配送单'
      } else {
        this.flag = true
        this.form.status = '全部'
      }
      this.getData()
    },
    gettabsoffset(tab) {
      this.$nextTick(() => {
        setTimeout(() => {
          const currentEL = this.$refs.tabs.$el.querySelector('.el-tabs__item.is-active') // 拿到当前高亮的

          const barEl = this.$refs.tabs.$el.querySelector('.el-tabs__active-bar')
          barEl.style.transform = `translateX(${currentEL.offsetLeft + 20}px)`
        })
      })
    },
    getTitleNumber() {
      this.$api.logisticsOrderCountNum().then((res) => {
        if (res.code != 0) return false
        if (res.data.length == 0) return false
        res.data.forEach((item) => {
          switch (item.status) {
            case '待发货配送单':
              this.orderForDeliveryTabText =
                this.$fanyi('待发货配送单') + ` (${item.num})`
              break
            case '运输中配送单':
              this.deliveryInTransitTabText =
                this.$fanyi('运输中配送单') + ` (${item.num})`
              break
            case '到达Rakumart运输中心配送单':
              this.deliveryFormToRakumartTransportCentreTabText =
                this.$fanyi('到达Rakumart物流中心') + ` (${item.num})`
              break
            case '西班牙派送配送单':
              this.spanishDeliveryOrderTabText =
                this.$fanyi('乌克兰派送中') + ` (${item.num})`
              break
            case '待报价':
              this.Tobequoted = this.$fanyi('待报价') + ` (${item.num})`
              break
            case '待支付':
              this.Tobepaid = this.$fanyi('待支付') + ` (${item.num})`
              break
            case '已签收配送单':
              this.internationalLogisticsTabText =
                this.$fanyi('已签收') + ` (${item.num})`
              break
            case '全部状态':
              this.allTabText = this.$fanyi('全部') + ` (${item.num})`
              break
          }
        })
        if (this.form.status != '全部') {
          this.gettabsoffset()
        }
      })
    },
    handleClick(tab) {

      this.form.page = 1
      switch (tab.name) {
        case '待发货配送单':
          this.$store.commit('updateRouterQuery', 'orderForDelivery')
          break
        case '运输中配送单':
          this.$store.commit('updateRouterQuery', 'deliveryInTransit')
          break
        case '到达Rakumart运输中心配送单':
          this.$store.commit(
            'updateRouterQuery',
            'deliveryFormToRakumartTransportCentre'
          )
          break
        case '西班牙派送配送单':
          this.$store.commit('updateRouterQuery', 'Usdeliveryunderway')
          break
        case '已签收配送单':
          this.$store.commit('updateRouterQuery', 'Signedandreceived')
          break
        case '全部':
          this.$store.commit('updateRouterQuery', '')
          break
      }
      this.form.status = tab.name
      this.getData()
    },
    // 获取数据
    getData() {
      this.loading = true
      let datas = {
        status: this.form.status,
        pageSize: this.form.pageSize,
        page: this.form.page,
        searchText: this.form.searchText,
        startTime: this.value[0],
        endTime: this.value[1],
      }

      this.$api.logisticsOrderList(datas).then((res) => {
        this.loading = false
        if (res.code != 0) return false
        res.data.data.forEach((item) => {
          item.porder_detail.forEach((items) => {
            items.order_detail_list = []
            items.order_detail.detail = JSON.parse(items.order_detail.detail)
            items.order_detail_list.push(items.order_detail)
          })
        })
        this.tableData = res.data.data

        this.value = ''
        this.dataProcessing(this.tableData)
        this.total = res.data.total
      })
    },
    //派送中配送单签收
    qianShou(sn) {
      this.$refs.dialog.open(
        this.$fanyi('是否签收选中的商品？'),
        (cancel) => {
          this.$api
            .internationalLogisticsClientReceive({ porder_sn: sn })
            .then((res) => {
              cancel()
              if (res.code != 0) return
              this.$message.success(this.$fanyi('签收成功'))
              this.getData()
              this.getTitleNumber()
            })
        },
        () => {

        }
      )
    },
    // 数据处理
    dataProcessing(data) {
      data.forEach((dataItem) => {
        // 添加是否显示子数据的参数
        dataItem.showChildData = false
        // 订单商品数量
        dataItem.orderNum = 0
        //订单内商品数量总计
        dataItem.totalNum = 0
        // 订单小计
        dataItem.totalPrice = 0
        // 国内运费
        dataItem.confirm_freight = 0
        dataItem.porder_detail.forEach((item) => {
          item.order_detail_list.forEach((goodsItem) => {
            dataItem.orderNum += goodsItem.num
            // 商品小计计算
            goodsItem.totalPrice = Number(
              this.$fun.ceil(Number(goodsItem.price) * goodsItem.num)
            )
            dataItem.totalPrice += Number(goodsItem.totalPrice)
            dataItem.totalNum += goodsItem.num
            dataItem.confirm_freight += Number(goodsItem.confirm_freight)
          })
        })
        dataItem.totalPrice = this.$fun.ceil(dataItem.totalPrice)
      })
    },
    handleSizeChange(val) {
      this.form.pageSize = val
      this.form.pageSize = 1
      this.getData(this.form)
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.getData(this.form)
    },
  },
}
</script>

<style lang="scss" scoped>
.NoDaTa {
  font-size: 14px;
  color: #909399;
  text-align: center;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 80px;
  border-radius: 0 0 12px 12px;

}

#userOrder {
  @import '../../../../css/mixin';
  width: 1060px;
  background: #FFFFFF;
  border-radius: 20px;
  overflow: hidden;



  button {
    cursor: pointer;
  }



  /deep/.el-range-separator {
    width: 3px;
    height: 20px;
    // background-color: pink;
    background: url('../../../../assets/date.png') no-repeat center;
  }



  /deep/ .el-date-editor {
    position: relative;

    .el-input__icon {
      display: none;
    }


  }


  .tabsContainer {
    border-radius: 0;
    border-bottom: 1px solid #dfdfdf !important;
    min-height: 58px;
    max-height: 98px;
    padding-top: 10px;

    /deep/ .el-tabs {
      max-width: 1020px;
      display: flex;

    }

    /deep/ .el-tabs__active-bar {
      background-color: #d12a1d;
      display: none;
    }

    /deep/ .el-tabs__nav-wrap::after {
      display: none;
    }

    /deep/ .el-icon-arrow-left {
      font-size: 14px;
    }

    /deep/.el-tabs__nav {

      flex-wrap: wrap;
      display: flex;
    }

    /deep/ .el-icon-arrow-right {
      font-size: 14px;
    }

    /deep/ .el-tabs__item {
      min-width: 80px;
      height: 40px;
      display: inline-block;
      font-size: 14px;


      margin-bottom: 5px;
      color: #121212;

      &:hover {
        color: #d12a1d;
      }

      &:nth-child(2) {
        padding-left: 20px;
      }
    }

    div {
      display: inline-block;
    }

    /deep/ .is-active {
      color: #d12a1d;

      &::after {
        content: '';
        position: absolute;
        width: 85%;
        left: 50%;
        transform: translateX(-50%);
        transition: all 0.3s ease-in-out;
        height: 2px;
        background-color: #d12a1d;
        bottom: -2px;
      }
    }
  }

  button {
    cursor: pointer;
  }

  .dingdan {
    padding-top: 20px;
    color: #ff730b;
    padding-bottom: 20px;

    &:hover {
      text-decoration: underline;
      color: #ff730b;
    }
  }



  .return {
    width: 130px;
    height: 40px;
    border-radius: 12px;
    border: 1px solid #D12A1D;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 16px;
    margin-left: 108px;
    color: #D12A1D;
  }

  .completed {
    width: 130px;
    height: 40px;
    border-radius: 12px;
    border: 1px solid #D12A1D;
    border-radius: 12px;
    border: 1px solid #D12A1D;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 16px;
    margin-left: 108px;
    color: #D12A1D;
  }




  .list {
    padding: 0 20px;
    padding-top: 20px;
    min-height: 300px;
    padding-bottom: 5px;



    .searchBox {
      display: flex;
      margin-bottom: 20px;


      .myInput {
        width: 400px;
        height: 40px;
        border-radius: 12px;
        position: relative;
        display: flex;
        align-items: center;
        // overflow: hidden;
        margin-right: 20px;

        >i {
          width: 20px;
          height: 24px;
          margin: 9px 11px 9px 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          color: #A2A2A2;
        }

        >input {
          border: 1px solid #e2e2e2;
          width: 100%;
          height: 100%;
          border-radius: 12px;
          font-size: 14px;
          padding-left: 40px;
          padding-right: 10px;
          transition: 0.3s;

          &:focus {
            border-color: #ff730b;
          }

          &::placeholder {
            color: #9a9a9a;
          }
        }
      }

      /deep/.el-date-editor {
        border-radius: 12px;
        width: 296px;
        height: 40px;
        margin-right: 20px;
        line-height: 32px !important;

        .el-input__inner {
          padding: 0px !important;
          border-radius: 12px;
        }

        .el-range-input {
          font-size: 14px;
          border-radius: 12px;
        }

        .el-range-separator {
          width: 50px;
          line-height: 23px;
        }

        .el-range__icon {
          line-height: 25px;
        }
      }


      .searchBtn {
        width: 80px;
        height: 40px;
        background: #D12A1D;
        border-radius: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
        text-align: center;
        font-size: 14px;


      }

      .cancelledBtn {
        width: 150px;
        height: 40px;
        border-radius: 12px;
        border: 1px solid #D12A1D;


        text-align: center;
        cursor: pointer;
        margin-left: 54px;
        font-weight: 400;
        font-size: 16px;
        color: #D12A1D;
        line-height: 40px;

      }
    }

    .dataBody {

      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #dfdfdf;

      .myTable {
        // 设置表格所有样式
        font-size: 14px;
        color: #2f2f2f;
        line-height: 19px;

        * {
          transition: 0.3s;
        }

        ul {
          display: flex;
          min-height: 60px;
          background: #fafafa;
          border-top: 1px solid #dfdfdf;

          &:nth-child(1) {
            border-top: none;
          }

          li {
            display: flex;
            justify-content: center;
            align-items: center;
            y // background-color: pink;

            &:nth-child(1) {
              border: 0;
            }

            img {
              cursor: pointer;
            }
          }
        }

        // 设置表头样式
        .tableHead {
          min-height: 50px;
          background: #F5F5F5;

          display: flex;
          align-items: center;
          justify-content: space-between;
          text-align: center;
          border-bottom: 0.5px solid #dfdfdf;
          padding: 5px;

          li {
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 14px;
            color: #121212;
            line-height: 16px;
            // height: 70px;

            justify-content: center;
          }

          .NO {
            flex: 0 0 51px;
          }

          .pordersn {
            flex: 0 0 184px;
            padding: 0 10px;
          }

          .ordersn {
            flex: 0 0 184px;
            padding: 0 10px;
            flex-direction: column;
          }

          .time {
            flex: 0 0 100px;
          }

          .signfortime {
            flex: 0 0 100px;
          }

          .paymenttime {
            flex: 0 0 100px;
          }

          .internationalfreight {
            flex: 0 0 100px;
            flex-shrink: 0;

          }

          .weight {
            flex: 0 0 80px;
          }

          .state {
            flex: 0 0 112px;
          }

          .operation {
            flex: 0 0 110px;
          }

          .flex230 {

            flex: 0 0 230px;
          }

          .flex190 {
            flex: 0 0 190px;
          }

          .flex194 {
            flex: 0 0 194px;
          }

          .flex80 {
            flex: 0 0 80px;
          }

          .flex90 {
            flex: 0 0 90px;
          }

          .flex210 {
            flex: 0 0 210px;
          }

          .flex110 {
            flex: 0 0 110px;
          }

          .flex113 {
            flex: 0 0 113px;
          }

          .flex150 {
            flex: 0 0 150px;
          }

          .flex170 {
            flex: 0 0 170px;
          }

          .flex285 {

            flex: 0 0 285px;
          }
        }

        // 设置表格内容样式
        .tableBody {

          ul {
            display: flex;
            align-items: center;
            justify-content: space-between;
            align-items: center;
            background-color: #fff;
          }

          li {
            display: flex;
            align-items: center;
            font-weight: 500;
            text-align: center;
            font-size: 14px;
            color: #121212;
            line-height: 16px;

            min-height: 60px;
            padding: 0 5px;
            border-left: 1px solid #dfdfdf;
            justify-content: center;

            &:nth-child(1) {
              border-left: none;
            }
          }

          .NO {
            flex: 0 0 50px;
          }

          .pordersn {
            flex: 0 0 184px;
            font-weight: 400;
            font-size: 14px;
            padding: 0 10px;
            color: #D12A1D;

            &:hover {
              cursor: pointer;
              text-decoration: underline;
            }
          }

          .ordersn {
            flex: 0 0 184px;
            font-weight: 400;
            font-size: 14px;
            flex-direction: column;
            padding: 0 10px;
            color: #D12A1D;

            P {
              margin-bottom: 5px;
            }

            &:hover {
              cursor: pointer;
              text-decoration: underline;
            }
          }

          .time {
            flex: 0 0 100px;
          }

          .signfortime {
            flex: 0 0 100px;
          }

          .paymenttime {
            flex: 0 0 100px;
          }

          .internationalfreight {
            flex: 0 0 100px;
          }

          .weight {
            flex: 0 0 80px;
          }

          .state {
            flex: 0 0 112px;
          }

          .operation {
            flex: 0 0 110px;
            padding: 0px;

            .Receipt {
              min-width: 90px;
              height: 40px;
              max-width: 100px;
              background: #2052CE;
              border-radius: 8px;
              font-weight: 400;
              font-size: 14px;
              color: #FFFFFF;
              display: flex;
              align-items: center;
              font-weight: 400;
              font-size: 14px;
              color: #FFFFFF;
              justify-content: center;

            }

            .pay {
              width: 90px;
              height: 40px;
              background: #D12A1D;
              display: flex;
              font-weight: 400;
              font-size: 14px;
              color: #FFFFFF;
              align-items: center;
              justify-content: center;
              padding: 0 10px;
              border-radius: 8px;
            }
          }

          .flex230 {

            flex: 0 0 230px;
          }

          .flex190 {
            flex: 0 0 190px;
          }

          .flex194 {
            flex: 0 0 194px;
          }

          .flex80 {
            flex: 0 0 80px;
          }

          .flex90 {
            flex: 0 0 90px;
          }

          .flex210 {
            flex: 0 0 210px;
          }

          .flex110 {
            flex: 0 0 110px;
          }

          .flex113 {
            flex: 0 0 113px;
          }

          .flex150 {
            flex: 0 0 150px;
          }

          .flex170 {
            flex: 0 0 170px;
          }

          .flex285 {

            flex: 0 0 285px;
          }
        }
      }
    }

    .allpag {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 30px 0px;

      .el-pagination {
        display: flex;
        align-items: center;
      }

      >a {
        display: inline-block;
        border: 1px solid #dcdfe6;
        height: 28px;
        // background-color: white;
        text-align: center;
        padding: 0 10px;
        font-size: 13px;
        line-height: 28px;
        border-radius: 0;
      }

      /deep/.btn-prev {
        width: 30px;
        height: 30px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #DFDFDF;
        padding: 0;
        margin-right: 15px;
        margin-left: 20px;

        .el-icon {
          font-size: 16px;
          color: #000000;
        }
      }

      /deep/.btn-next {
        width: 30px;
        height: 30px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #DFDFDF;
        padding: 0;
        margin-left: 15px;



        .el-icon {
          font-size: 16px;
          color: #000000;
        }
      }

      /deep/ .el-pagination__jump {

        .el-input {
          width: 50px;
          height: 30px;
          background: #FFFFFF;
          border-radius: 8px;
          margin-left: 5px;

          font-weight: 400;
          font-size: 14px;
          color: #000000;

          .el-input__inner {
            height: 30px;
            border-radius: 8px;
          }

        }
      }

      /* 分页被选中的页码样式 */
      /deep/ .el-pager li {
        margin: 0 5px;
        width: 30px;
        line-height: 30px;
        height: 30px;
        border-radius: 8px;
        // box-shadow: 0 0 6px 0 rgba(61, 61, 61, 0.1);

        &:hover {
          color: #D12A1D;
        }

        &.active {
          width: 30px;

          height: 30px;
          background: #D12A1D;
          line-height: 30px;
          color: #fff;
          border-radius: 8px;
        }
      }
    }
  }
}
</style>
